import React, { Component } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";
import LoadingBar from "react-top-loading-bar";
import PopUp from "../../../pages/PopUpAlert";
import API from "../../../../Services/Api";
import { checkResponseError } from "../../../../Services/Utils";
import { connect } from "react-redux";
import * as R from "ramda";
import { Redirect } from "react-router-dom";
import AuthAction from "../../../../Redux/AuthRedux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleInput from "../../../../modules/SimpleInput";
import NormalInput from "../../../../modules/NormalInput";

import DDLCompany from "../../../../modules/commons/DDLCompany";
import Button from "../../../../modules/commons/Button";
import SimpleInputRow from "../../../../modules/SimpleInputRow";
import SimpleInputRowSmall from "../../../../modules/SimpleInputRowSmall";
import SimpleSearch from "../../../../modules/SimpleSearch";
import FormPart from "./formKsu";
import FormKSU from "../../inventory/inventory/formKSU";
import FormKsu from "./formKsu";

const UtilsButtonLogin = require("../../../../Services/UtilsButtonLogin");

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class Ksu extends Component {
  constructor() {
    super();
    this.state = {
      rawData: [],
      dataTable: [
        [
          "1",
          "No Penerima 1",
          "71649210",
          "25-09-24",
          "2198ADNB190",
          "Ahmad Safrul",
          "123678",
          "Fix",
        ],
        [
          "2",
          "No Penerima 2",
          "38471926",
          "12-06-24",
          "8923MNJ123",
          "Siti Rahmah",
          "456789",
          "Belum Fix",
        ],
        [
          "3",
          "No Penerima 3",
          "56283947",
          "18-03-24",
          "6231XYZ456",
          "Budi Santoso",
          "987654",
          "Fix",
        ],
        [
          "4",
          "No Penerima 4",
          "91827364",
          "05-11-24",
          "4567PQR789",
          "Dewi Susanti",
          "246810",
          "Belum Fix",
        ],
        [
          "5",
          "No Penerima 5",
          "35467281",
          "30-08-24",
          "7890ABC123",
          "Rudi Hermawan",
          "135790",
          "Fix",
        ],
        [
          "6",
          "No Penerima 6",
          "82637451",
          "14-02-24",
          "2345LMN678",
          "Fitriani",
          "678901",
          "Belum Fix",
        ],
        [
          "7",
          "No Penerima 7",
          "16384927",
          "21-07-24",
          "9012QRS345",
          "Harianto",
          "234567",
          "Fix",
        ],
        [
          "8",
          "No Penerima 8",
          "49782315",
          "09-05-24",
          "6789STU012",
          "Sri Wahyuni",
          "789012",
          "Belum Fix",
        ],
      ],
      selectedIndex: [],
      dmlchoices: [""],
      createVisible: false,
      updateVisible: false,
      deletePopUpVisible: false,
      savePopUpVisible: false,
      loadSave: false,
      allowResize: false,
      defaultSize: 0,
      minSize: 0,
      maxSize: 0,
      timeout: 1000 * 100 * 9,
      isTimedOut: false,
      toCount: 0,
      table_limit: 10,
      table_page: 0,
      table_query: "",
      createVisible2: false,
      tabIndex: 0,
      checkTab: false,
      data: {},
      dataDto: {},
      buttonAccess: {},
      cari: null,
      parts: null,
    };
    this.idleTimer = null;
  }

  logout() {
    this.props.authLogout();
    return <Redirect to={{ pathname: "/" }} />;
  }

  onAction() {
    this.setState({ isTimedOut: false });
  }

  onActive() {
    this.setState({ isTimedOut: false });
  }

  onIdle() {
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      alert("Your session has timed out. Please log in again");
      this.logout();
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  componentDidMount() {
    UtilsButtonLogin.buttonAccess("MASTER-022", (response) => {
      // console.log("ORI ", response);
      this.setState(
        {
          buttonAccess: response,
        },
        () => {
          this.getCountPage(this.state.table_page, this.state.table_limit);
        }
      );
    });
  }

  getCountPage = async (page, limit) => {
    console.log("getCountPage");
    let payload = {
      // limit: limit,
      // offset: page,
      // filter: this.state.table_query,
      // companyId: this.state.dataDto.companyId,
      // companyGroupId: null,
      // category: null,
      // isActive: null,
      // sortBy: this.state.dataDto.sortBy ?? "",
      // orderBy: this.state.dataDto.orderBy ?? "",
    };
    console.log(payload);

    // let res = await API.create('LOCAL_BANK').getBank(payload)
    // if (res.ok) {
    //     console.log('here')
    //     if (res.data.data === null) {
    //         this.setState({ dataTable: [] })
    //     } else {
    //         // console.log(JSON.stringify(res.data.data, null, 2));
    //         let dataTable = res.data.data && res.data.data.map((value) => {
    //             const { bankcode, bankname, accountnumber, address, kecamatan, kota, provinsi, kodepos, phonenumber, namadealer, integration, status } = value;
    //             return [
    //                 bankcode,
    //                 bankname,
    //                 accountnumber,
    //                 address,
    //                 kecamatan,
    //                 kota,
    //                 provinsi,
    //                 kodepos,
    //                 phonenumber,
    //                 namadealer,
    //                 integration,
    //                 status?"ACTIVE":"NONACTIVE",
    //             ];
    //         });
    //         console.log('datatable', dataTable)
    //         this.setState({
    //             rawData: res.data.data && res.data.data.listUser,
    //             dataTable,
    //             toCount: res.data.data && res.data.data.dataOfRecord
    //         })
    //         this.onFinishFetch();
    //     }
    // } else{
    //     console.log('error')
    // }
  };

  handleClearUser = (e) => {
    this.setState(
      {
        table_page: 0,
        toCount: 0,
        data: {},
        dataDto: {},
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  handleSearch = (eventSearch) => {
    this.setState(
      {
        table_page: 0,
        dataDto: eventSearch ? this.state.data : this.state.dataDto,
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  isLoad(visible) {
    this.setState({ loadSave: visible });
  }

  checkResponse(res, type) {
    if (res.ok && res.data.status === "S") {
      type === "delete" && this.setState({ deletePopUpVisible: false });
      setTimeout(() => {
        this.openSavePopUp();
      }, 500);
    } else {
      this.isLoad(false);
      checkResponseError(res);
    }
  }

  onchangeInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  handleSubmit = async (response) => {
    this.checkResponse(response);
  };

  handleDelete = async () => {
    this.isLoad(true);
    let payload = { ...this.state.rawData[this.state.selectedIndex] };
    payload.action = "DELETE";

    let response = await API.create("MASTERDATA_EKSAD").postSaveUser(payload);
    this.checkResponse(response, "delete");
    this.isLoad(false);
  };

  handlePopUp = () => {
    this.handleSearch();
    this.setState({
      savePopUpVisible: false,
      createVisible: false,
      createVisible2: false,
    });
  };

  startFetch = () => {
    this.LoadingBar.continousStart();
  };

  onFinishFetch = () => {
    if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
  };

  openCreateForm = () => {
    this.setState({ createVisible: !this.state.createVisible });
    console.log("openCreateForm");
  };

  openUpdateForm = () => {
    this.setState({ updateVisible: !this.state.updateVisible });
  };

  openSavePopUp = () => {
    this.setState({
      savePopUpVisible: !this.state.savePopUpVisible,
      loadSave: false,
    });
  };

  openDeletePopup = (index) => {
    this.setState({
      deletePopUpVisible: !this.state.deletePopUpVisible,
      selectedIndex: index,
    });
  };

  columnsUser = [
    { name: "No" },
    { name: "Nama Penerima" },
    { name: "No Shipping" },
    { name: "Tgl Penerima" },
    { name: "No Invoice" },
    { name: "Nama Supplier" },
    { name: "No PO" },
    { name: "Type" },
    {
      name: "Receive",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                style={{ marginLeft: "-5px" }}
                className="btn btn-back"
                type="button"
                onClick={this.openCreateForm.bind(this)}
              >
                <span>Process</span>
              </Button>
              <Button
                className="btnAct"
                style={{ marginRight: 15, backgroundColor: "transparent" }}
                onClick={this.opSidePage("slide-menu-view", tableMeta.rowIndex)}
                permission=""
              >
                <i
                  className="fa fa-lw fa-print"
                  style={{
                    backgroundColor: "transparent",
                    marginLeft: 10,
                    color: "red",
                    fontSize: 20,
                  }}
                />
              </Button>
            </div>
          );
        },
      },
    },
  ];

  opSidePage = (menu, data) => (e) => {
    e.preventDefault();
    let selectedIndex = data;
    this.setState({
      updateVisible: false,
    });

    switch (menu) {
      case "slide-menu-1":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "update",
        });
        break;
      case "slide-menu-view":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "view",
        });
        break;
      default:
        break;
    }
  };
  resetTab = (tabIndex) => {
    this.setState({ tabIndex });
    if (tabIndex === 0) {
      this.getCountPage(this.state.table_page, this.state.table_limit);
    }
  };

  render() {
    if (R.isNil(this.props.auth.user))
      return <Redirect to={{ pathname: "/" }} />;
    let { toCount, table_query } = this.state;
    let tableOptions = {
      ...options,
      // serverSide: true,
      count: toCount,
      // selectableRowsHeader: true,
      // selectableRows: "multiple",
      filter: false,
      search: false,
      viewColumns: false,
      searchText: table_query,
      rowsPerPage: this.state.table_limit,
      page: this.state.table_page,
      onColumnSortChange: (changedColumn, direction) => {
        let order = "desc";
        if (direction === "ascending") {
          order = "asc";
        }

        let columnOrder = "";

        if (changedColumn === "Company") {
          columnOrder = "companyCode";
        }

        if (changedColumn === "Username") {
          columnOrder = "username";
        }

        if (changedColumn === "Email") {
          columnOrder = "email";
        }

        if (changedColumn === "Category") {
          columnOrder = "category";
        }

        if (changedColumn === "Employee Name") {
          columnOrder = "name";
        }

        if (changedColumn === "Status") {
          columnOrder = "status";
        }

        this.columnsUser.map((value, index) => {
          if (changedColumn === value.name && value.name !== "Action") {
            value.options = { sortDirection: order };
          } else {
            value.options = { ...value.options, sortDirection: "none" };
          }
        });

        this.setState(
          {
            dataDto: {
              ...this.state.dataDto,
              sortBy: columnOrder,
              orderBy: order,
            },
          },
          () => {
            this.getCountPage(this.state.table_page, this.state.table_limit);
          }
        );
      },
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ table_page: tableState.page });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.setState({ table_limit: tableState.rowsPerPage });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            let searchText = tableState.searchText ? tableState.searchText : "";
            this.setState({ table_query: searchText }, () => {
              this.handleSearch();
            });
            break;
          default:
            break;
        }
      },
    };
    return (
      <div className="main-slider">
        <div className="padding-tbl-monitoring">
          <LoadingBar onRef={(ref) => (this.LoadingBar = ref)} />
          <Tabs
            selectedIndex={this.state.tabIndex}
            onSelect={(tabIndex) => this.resetTab(tabIndex)}
          >
            <TabList>
              <Tab>Receiving KSU</Tab>
            </TabList>
            <TabPanel>
              <div>
                <div
                  style={{
                    display: "flex",
                    marginBottom: "15px",
                    marginTop: "15px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <Button
                      type="button"
                      style={{
                        width: "130px",
                        height: "40px",
                        marginRight: 15,
                        marginTop: 5,
                      }}
                      className="btn btn-plus background-red margin-left-15px"
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm.bind(this)}
                    >
                      <span>
                        <i
                          className="fa fa-plus"
                          style={{ marginRight: "10px" }}
                        />
                        TAMBAH
                      </span>
                    </Button>
                    <SimpleDate
                      date={this.state.data.startDate}
                      minDate={new Date()}
                      backdates
                      onChange={(date) => this.onChangeDate(date, "startDate")}
                    />
                  </div>
                  <div style={{ display: "flex", marginLeft: "600px" }}>
                    <div style={{ width: 200, marginRight: 20 }}>
                      <DDLCompany
                        box={"search"}
                        hierarchy={false}
                        onChangeCombo={(value) => {
                          this.setState({
                            data: { ...this.state.data, ...value },
                          });
                        }}
                        valueCombo={this.state.data.companyIdSelect}
                      />
                    </div>

                    <div>
                      <SimpleSearch
                        name="noka"
                        // readOnly={this.props.type !== "create"}
                        value={this.state.data.noka}
                        onChange={this.onchangeInput}
                      />
                    </div>
                    <div style={{ marginTop: "3px", marginLeft: "20px" }}>
                      <Button
                        type="button"
                        style={{ width: "50px" }}
                        className="btn btn-plus background-red "
                        valueCombo={this.state.data.companyIdSelect}
                        onClick={this.openCreateForm.bind(this)}
                      >
                        <span>
                          <i className="fa fa-qrcode" />
                        </span>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    key={toCount}
                    title={"KSU List"}
                    // subtitle={"Setting data of Jasa List"}
                    data={this.state.dataTable}
                    columns={this.columnsUser}
                    options={tableOptions}
                    // buttonCreate={this.state.buttonAccess.btnAdd}
                    // onCreate={this.openCreateForm.bind(this)}
                  />
                </MuiThemeProvider>
                <Button
                  style={{ marginLeft: "1290px", width: "50", marginTop: 10 }}
                  className="btn btn-back"
                  type="button"
                >
                  <span>PRINT</span>
                </Button>
              </div>
            </TabPanel>
          </Tabs>
        </div>

        <div>
          {this.state.createVisible && (
            <FormKsu
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.updateVisible && (
            <FormKsu
              type={this.state.popupType === "update" ? "edit" : "view"}
              data={this.state.rawData[this.state.selectedIndex]}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openUpdateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.savePopUpVisible && (
            <PopUp
              type={"save"}
              class={"app-popup app-popup-show"}
              onClick={this.handlePopUp.bind(this)}
            />
          )}

          {this.state.deletePopUpVisible && (
            <PopUp
              type={"delete"}
              class={"app-popup app-popup-show"}
              onClickDelete={this.handleDelete}
              onClick={this.openDeletePopup}
              isLoading={this.state.loadSave}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    masterdata: state.masterdata,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Ksu);
